import React, { useMemo } from 'react';
import {
  Space,
  Button,
  Dropdown,
  Avatar,
} from '@lockerpm/design';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import authServices from '../../services/auth';
import userServices from '../../services/user';

import global from '../../config/global';
import { updateLocale } from '../../utils/common'

import {
  LogoutOutlined,
} from '@ant-design/icons'
  
function DropdownMenu() {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.auth.userInfo);
  const locale = useSelector((state) => state.system.locale);
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace);

  const AvatarIcon = useMemo((size = 32) => {
    if (userInfo?.avatar) {
      return <Avatar
        size={size}
        src={userInfo?.avatar}
      />
    }
    return <Avatar
      size={size}
      style={{
        backgroundColor: 'var(--sidebar-menu-group-color)',
        color: 'var(--sidebar-menu-active-background-color)'
      }}
    >
      {userInfo?.full_name?.slice(0, 1)?.toUpperCase() || 'S'}
    </Avatar>
  }, [userInfo])

  const items = useMemo(() => {
    return [
      {
        key: 'account',
        icon: AvatarIcon,
        label: <div className='account-info'>
          <div>{userInfo?.full_name}</div>
        </div>,
      },
      {
        key: 'workspace',
        label: <span>
          <span className='font-semibold'>
            {t('common.workspace')}:</span> <span>{selectedWorkspace?.name}
          </span>
        </span>,
      },
      {
        key: 'language',
        label: <span>
          <span className='font-semibold'>{t('common.language')}:</span> <span>
            {t(global.constants.LANGUAGES.find(l => l.value === locale)?.label) || 'English'}
          </span>
        </span>,
        children: global.constants.LANGUAGES.map((l) => ({
          key: l.value,
          label: t(l.label),
          disabled: l.disabled
        }))
      },
      {
        type: 'divider',
      },
      {
        key: 'logout',
        danger: true,
        icon: <LogoutOutlined />,
        label: <span>{t('sidebar.logout')}</span>
      },
    ].filter((item) => !item.hide)
  }, [
    selectedWorkspace,
    JSON.stringify(userInfo),
    locale,
    t
  ])


  const dropdownClick = (item) => {
    if (item.key === 'account') {
      global.navigate('ACCOUNT_DETAILS')
    } else if (item.key === 'logout') {
      authServices.logout();
    } else if (item.key === 'workspace') {
      global.navigate('PROJECTS', { workspace_id: selectedWorkspace?.id })
    } else if (global.constants.LANGUAGES.find(l => l.value === item.key)) {
      updateLocale(item.key);
      if ([global.constants.LANGUAGE.EN, global.constants.LANGUAGE.VI].includes(item.key)) {
        userServices.update({ language: item.key, username: userServices.account_info().username })
      }
    }
  }

  return (
    <Dropdown
      menu={{
        items,
        defaultSelectedKeys: [],
        onClick: dropdownClick
      }}
      placement="bottomLeft"
      trigger={'click'}
    >
      <Space wrap>
        <Button
          type='text'
          className='avatar-button'
          shape='circle'
          icon={AvatarIcon}
        />
      </Space>
    </Dropdown>
  );
}

export default DropdownMenu;
